module.exports = __webpack_public_path__ + "static/media/SWSCRC6-32.69ce7139.mp3";